module.exports = __webpack_public_path__ + "static/media/normal-vision.1e79e2bb.png";